import { CONNECT_ERROR, COUNTRY_CODE_ES } from 'commonsConstants/countryCodes';
import { VIDEO_CALL } from 'constants/identityMethod';
import {
    CALLCENTER_KO,
    CODEC_ERROR,
    COMPLETED,
    DEFINITE_KO,
    EXPIRED_DOCUMENT,
    LOW_QUALITY,
    NON_EXCLUSIVE,
    WAITING,
    WRONG_FACE_MATCH,
    WRONG_PERMISSIONS,
} from 'constants/video/status';

const mapVideocallStatus = (status, callback) => {
    switch (status) {
        case '0':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '10':
        case '11':
        case '17':
            return callback(NON_EXCLUSIVE);
        case 'asnef_error':
            return callback(CALLCENTER_KO);
        case '9':
        case '12':
        case '14':
            return callback(DEFINITE_KO);
        case '15':
            return callback(COMPLETED);
        case '16':
            return callback(WAITING);
        case '13':
            return __ORIGIN_COUNTRY__ === COUNTRY_CODE_ES ? callback(NON_EXCLUSIVE) : callback(DEFINITE_KO);
        default:
            return callback(status);
    }
};

const mapVideSelfieStatus = (status, callback) => {
    switch (status) {
        case 'asnef_error':
            return callback(CALLCENTER_KO);
        case '3':
        case '5':
        case '54':
        case '57':
            return callback(CONNECT_ERROR);
        case '20':
            return callback(LOW_QUALITY);
        case '27':
            return callback(WRONG_PERMISSIONS);
        case '6':
        case '15':
        case '21':
        case '23':
            return callback(WRONG_FACE_MATCH);
        case '25':
        case '26':
            return callback(COMPLETED);
        case '24':
            return callback(EXPIRED_DOCUMENT);
        case '22':
            return callback(DEFINITE_KO);
        case '56':
        case '58':
            return callback(CODEC_ERROR);
        default:
            return callback(status);
    }
};

const mapVideoStatus = (status, method, callback, userProfile = {}) => {
    if (method === VIDEO_CALL) {
        return mapVideocallStatus(status, callback);
    }

    return mapVideSelfieStatus(status, callback, userProfile);
};

export { mapVideoStatus, mapVideocallStatus };
